export default "__VITE_ASSET__bf4aa338__"